import { render, staticRenderFns } from "./NewsAnnouncement.vue?vue&type=template&id=1c9e01e4&scoped=true&"
import script from "./NewsAnnouncement.vue?vue&type=script&lang=js&"
export * from "./NewsAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "@/tbs/stylesheet/dynamic.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./NewsAnnouncement.vue?vue&type=style&index=1&id=1c9e01e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9e01e4",
  null
  
)

export default component.exports